import {useEffect,useRef,useState} from "react";
import {lookupPostalCities} from "../services/postalCities";
export function usePostalCities({postCode,town,onTownChange,enabled=true}) {
 const [cities,setCities]=useState([]),[loading,setLoading]=useState(false),[error,setError]=useState("");
 const latest=useRef({town,onTownChange});latest.current={town,onTownChange};
 const previousCode=useRef(String(postCode||""));
 useEffect(()=>{
  const code=String(postCode||"").trim();
  const changed=previousCode.current!==code;previousCode.current=code;
  setCities([]);setError("");setLoading(false);
  if(!enabled || !/^\d{5}$/.test(code))return;
  const initialTown=latest.current.town;
  const controller=new AbortController();let active=true;
  const timer=setTimeout(async()=>{
   setLoading(true);
   const timeout=setTimeout(()=>controller.abort(),8000);
   try {
    const result=await lookupPostalCities(code,{signal:controller.signal});
    if(!active)return;
    setCities(result);
    // Never replace a manually edited city while the request is running.
    if(result.length===1 && (changed || !initialTown) && latest.current.town===initialTown)latest.current.onTownChange(result[0]);
    if(result.length>1 && changed && latest.current.town===initialTown && !result.includes(initialTown))latest.current.onTownChange("");
   }catch{if(active)setError("Villes indisponibles — saisie manuelle possible.");}
   finally{clearTimeout(timeout);if(active)setLoading(false);}
  },250);
  return ()=>{active=false;clearTimeout(timer);controller.abort();};
 },[postCode,enabled]);
 return {cities,loading,error};
}
